import { CSS_VAR_OF, OpsTokens } from "./tokens";

export const Token = Object.fromEntries(Object.entries(CSS_VAR_OF).map(([key, cssVar]) => [key, `var(${cssVar})`])) as Record<
  keyof OpsTokens,
  string
>;
